<template>

  <div>
    <div class="header-container">
      <h2>Registro laboral</h2>
      <labor-registry-filter v-model="filters" @click-search="filterLaborRegistry" />
      <b-pagination v-model.number="paginator.page" @change="loadLaborRegistries" align="center" :per-page="paginator.perPage" :total-rows="paginator.totalElements"/>
    </div>
    <div class="fixed-table-container">
      <labor-registry-table :items="paginator.content" />
    </div>
  </div>

</template>

<script>

import LaborRegistryFilter from './partials/LaborRegistryFilter'
import LaborRegistryTable from './partials/LaborRegistryTable'
import api from '@/api/api'

export default {
  name: 'LaborRegistryIndex',
  components: {
    LaborRegistryFilter,
    LaborRegistryTable
  },
  created() {
    this.inicializaFechas()
    this.loadLaborRegistries(1)
  },
  data() {
    return {
      filters: {
        user: null,
        from: null,
        to: null
      },
      paginator: {
        page: 1,
        perPage: 10,
        totalElements: 0,
        content: []
      }
    }
  },
  methods: {
    filterLaborRegistry() {
      var hayFechas = (this.filters.from != null) && (this.filters.from !== '') && (this.filters.to != null) && (this.filters.to !== '')
      if (hayFechas) {
        var fechasCorrectas = this.filters.to >= this.filters.from
        if (fechasCorrectas) {
          var diferenciaDias = this.diferenciaFechas()
          var menosDe6Meses = diferenciaDias <= 186
          if (menosDe6Meses) {
            this.loadLaborRegistries(1)
          } else {
            this.$toastr('error', 'El intervalo de fechas no ha de ser mayor de 6 meses')
          }
        } else {
          this.$toastr('error', 'La frecha "Hasta" no puede ser anterior a "Desde"')
        }
      } else {
        this.$toastr('error', 'Las fechas son oblitagorias')
      }
    },
    onPageChange(page) {
      this.loadLaborRegistries(page)
    },
    loadLaborRegistries(page = this.paginator.page) {
      api.workOrder.timeRecords({page: page - 1, ...this.params}).then(paginator => {
        this.paginator.content = paginator.content
        this.paginator.totalElements = paginator.totalElements
        this.paginator.page = page
      })
    },
    inicializaFechas() {
      var hoy = new Date()
      var primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
      this.filters.from = this.formateaFecha(primerDiaMes)
      var ultimoDiaMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0)
      this.filters.to = this.formateaFecha(ultimoDiaMes)
    },
    formateaFecha(date) {
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var dt = date.getDate()
      if (dt < 10) {
        dt = '0' + dt
      }
      if (month < 10) {
        month = '0' + month
      }
      return year + '-' + month + '-' + dt
    },
    diferenciaFechas() {
      var from = new Date(this.filters.from)
      var to = new Date(this.filters.to)
      var diffTime = Math.abs(to - from)
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    }
  },
  computed: {
    params() {
      return {
        ...this.filters,
        size: this.paginator.perPage
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/laborRegistry/Index.vue